import {
  GET_ALL_LICENSES_REQUEST,
  GET_ALL_LICENSES_SUCCESS,
  GET_ALL_LICENSES_FAIL,
  GET_LICENSE_BY_ID_REQUEST,
  GET_LICENSE_BY_ID_SUCCESS,
  GET_LICENSE_BY_ID_FAIL,
  GET_ALL_ACTIVE_LICENSES_REQUEST,
  GET_ALL_ACTIVE_LICENSES_SUCCESS,
  GET_ALL_ACTIVE_LICENSES_FAIL,
  ADD_LICENSE_REQUEST,
  ADD_LICENSE_SUCCESS,
  ADD_LICENSE_FAIL,
  UPDATE_LICENSE_STATUS_REQUEST,
  UPDATE_LICENSE_STATUS_SUCCESS,
  UPDATE_LICENSE_STATUS_FAIL
} from "../constants/LicenseConstants";

import LicenseService from "../Services/LicenseService";

export const GetAllLicensesAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_LICENSES_REQUEST });

    const { data } = await LicenseService.GetAllLicenses();

    dispatch({
      type: GET_ALL_LICENSES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_LICENSES_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const GetLicenseByIdAction = (licenseId) => async (dispatch) => {
  try {
    dispatch({ type: GET_LICENSE_BY_ID_REQUEST });

    const { data } = await LicenseService.GetLicenseById(licenseId);

    dispatch({
      type: GET_LICENSE_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_LICENSE_BY_ID_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const GetAllActiveLicensesAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_ACTIVE_LICENSES_REQUEST });

    const { data } = await LicenseService.GetAllActiveLicenses();

    dispatch({
      type: GET_ALL_ACTIVE_LICENSES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ACTIVE_LICENSES_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const AddLicenseAction = (licenseData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_LICENSE_REQUEST });

    const { data } = await LicenseService.AddLicense(licenseData);

    dispatch({
      type: ADD_LICENSE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADD_LICENSE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const UpdateLicenseStatusAction = (licenseId, status) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_LICENSE_STATUS_REQUEST });

    const { data } = await LicenseService.UpdateLicenseStatus(licenseId, status);

    dispatch({
      type: UPDATE_LICENSE_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_LICENSE_STATUS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};